import jwtDecode from "jwt-decode";
export default function OptionHeaders() {
  const token = localStorage.getItem("token") && localStorage.getItem("token");
  if (token) {
    try {
      const { jti, sid } = jwtDecode(token);
      const optionHeaders = {
        token: `Bearer ${token}`,
        baseUrl: `${process.env.REACT_APP_WEB_API}`,
        language: localStorage.getItem("locale") || "vi",
        userId: jti,
        employeOid: sid,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
      };

      return optionHeaders;
    } catch (error) {
      // console.log("redux/options token", error);
    }
  } else {
    try {
      return {
        token: "",
        baseUrl: `${process.env.REACT_APP_WEB_API}`,
        language: localStorage.getItem("locale") || "vi",
        userId: "",

        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
      };
    } catch (error) {
      // console.log("redux/options no token", error);
    }
  }
}
